module.exports = __webpack_public_path__ + "logo_full-efefe08462ede002abb7fc1e69005cbb.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/logo_full.png
// module id = 279
// module chunks = 88